
if(!window._babelPolyfill){
	require("babel-polyfill");
}

if(!window.fetch){
	require('whatwg-fetch');
}